<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box">
        <div class="accountright_cont_box">
          <div class="flex_center_between_box">
            <h2 class="history_box-head">
              {{ $t("UserSettings.LanguageandLocation") }}
            </h2>
            <button class="btn_blue flex_center change_btn">
              {{ $t("MyAccount.Save") }}
            </button>
          </div>
          <div class="his_sel_box">
            <div class="sel_box computer_right_cont_box">
              <div class="title2 margin-top20">
                {{ $t("UserSettings.Language") }}
              </div>
              <el-select
                v-model="IndicatorsValType"
                :placeholder="$t('UserSettings.Selectyourpreferedlanguage')"
              >
                <el-option
                  v-for="(item, index) in type"
                  :key="index"
                  :label="
                    item.type == '1'
                      ? 'Online data'
                      : item.type == '2'
                      ? 'Offline data'
                      : item.type
                  "
                  :value="item.type"
                ></el-option>
              </el-select>
            </div>
            <div class="sel_box computer_right_cont_box">
              <div class="title2 margin-top30">
                {{ $t("UserSettings.Location") }}
              </div>
              <el-select
                v-model="IndicatorsValType"
                :placeholder="$t('UserSettings.Selectyourlocation')"
              >
                <el-option
                  v-for="(item, index) in type"
                  :key="index"
                  :label="
                    item.type == '1'
                      ? 'Online data'
                      : item.type == '2'
                      ? 'Offline data'
                      : item.type
                  "
                  :value="item.type"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="userSettingbottom">
            <div class="flex_center_between_box">
              <h2 class="history_box-head">
                {{ $t("UserSettings.NotificationSetting") }}
              </h2>
            </div>
            <div class="his_sel_box" style="width: 100%">
              <div class="flex_center_between_box sel_box switchbox">
                <span>{{ $t("UserSettings.EmailNotification") }}</span>
                <el-switch
                  v-model="switchto"
                  active-value="1"
                  inactive-value="0"
                  active-color="#13ce66"
                ></el-switch>
              </div>
              <div class="flex_center_between_box sel_box switchbox">
                <span>{{ $t("UserSettings.ServiceUpdates") }}</span>
                <el-switch
                  v-model="switchtotwo"
                  active-value="1"
                  inactive-value="0"
                  active-color="#13ce66"
                ></el-switch>
              </div>
              <div class="flex_center_between_box sel_box switchbox">
                <span>{{ $t("UserSettings.CompanyNews") }}</span>
                <el-switch
                  v-model="switchtotree"
                  active-value="1"
                  inactive-value="0"
                  active-color="#13ce66"
                ></el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";

export default {
  mixins: [mixins1],
  data() {
    return {
      value1: "",
      CategoryVal: "",
      type: [],
      IndicatorsValType: "",
      switchto: "0",
      switchtotwo: "1",
      switchtotree: "0",
      yourUsagelist: [
        {
          UserAccount: "Julian Chen@gmail.com",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Julian Chen@gmail.com",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Julian Chen@gmail.com",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc. Apple Inc. Apple Inc. Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Julian Chen@gmail.com",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc. Apple Inc. Apple Inc. Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },

        {
          UserAccount: "Julian Chen@gmail.com",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc. Apple Inc. Apple Inc. Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Julian Chen@gmail.com",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Ruling documents",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc. Apple Inc. Apple Inc. Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Ruling documents",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Ruling documents",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
      ],
      window: window,
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {},

  methods: {
    apptablelist() {
      this.yourUsagelist.push(
        {
          UserAccount: "Ruling documents",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Ruling documents",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Ruling documents",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
        {
          UserAccount: "Ruling documents",
          Date: "2024-07-26  11:23:32",
          CompanyName: "Apple Inc.",
          UnitsUsed: "2",

          UsageType: "News Saction",
        },
      );
    },
  },
};
</script>
<style scoped>
.accountright_cont_box {
  height: calc(100vh - 136px);
}
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.userSettingbottom {
  margin-top: 30px;
  border-top: 1px solid #dddddd;
  padding-top: 30px;
}

.switchbox {
  margin-top: 30px;
  font-size: 20px;
  align-items: center;
}
.title2 {
  font-size: 18px;
  margin-bottom: 10px;
}
.history_box-head {
  font-size: 24px !important;
  line-height: 28px !important;
  color: #1290c9;
}

.sel_box {
  width: 40%;
  min-width: 530px;
  position: relative;
}
.sel_box /deep/ .el-select {
  width: 100%;
  height: 50px !important;
  line-height: 50px !important;
  border-color: #ccc !important;
  border-radius: 10px;
  font-size: 20px;
  color: #1a2332;
}
.sel_box /deep/ .el-input--suffix .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  font-size: 20px;
  padding-left: 10px !important;
}
.sel_box /deep/ .el-input__inner::placeholder {
  color: #cccccc;
}

.information-content {
  display: flex;
}
.account_form_itemA {
  align-items: center;
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.his_sel_box .information-content {
  justify-content: flex-start;
  gap: 40px;
}
.btn_eee {
  background: #eee !important;
  color: #1a2332;
}
.el-select-dropdown__item {
  font-size: 20px !important;
  color: #1a2332;
}
/deep/ .el-radio__label {
  font-size: 20px;
  color: #1a2332;
}
@media screen and (max-width: 1920px) {
  .userSettingbottom {
    margin-top: 22px;
    padding-top: 22px;
  }
  .title2 {
    font-size: 16px;
  }
  .history_box-head {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  .account_form_itemA {
    margin-top: 12px !important;
  }
  .his_sel_box .information-content {
    gap: 30px;
  }
  .el-select-dropdown__item {
    font-size: 16px !important;
  }
  /deep/ .el-radio__label {
    font-size: 16px;
  }
  .sel_box {
    min-width: 400px;
  }

  .sel_box /deep/ .el-select {
    height: 36px !important;
    line-height: 36px !important;
    border-radius: 7px;
    font-size: 16px;
  }
  .sel_box /deep/ .el-input--suffix .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
    font-size: 16px;
  }
  .switchbox {
    margin-top: 22px;
    font-size: 16px;
  }
}
@media screen and (max-width: 1441px) {
  .userSettingbottom {
    margin-top: 20px;
    padding-top: 20px;
  }
  .history_box-head {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  .account_form_itemA {
    margin-top: 10px !important;
  }
  .his_sel_box .information-content {
    gap: 26px;
  }
  .el-select-dropdown__item {
    font-size: 16px !important;
  }
  /deep/ .el-radio__label {
    font-size: 16px;
  }
  .sel_box {
    min-width: 360px;
  }

  .sel_box /deep/ .el-select {
    height: 32px !important;
    line-height: 32px !important;
    border-radius: 6px;
    font-size: 14px;
  }
  .sel_box /deep/ .el-input--suffix .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    font-size: 14px;
  }
  .switchbox {
    margin-top: 20px;
    font-size: 16px;
  }
}
</style>
